"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ethers_1 = require("ethers");
const config_json_1 = __importDefault(require("./config.json"));
const ChainConfig = {
    test: config_json_1.default.TEST_CONFIG,
    testnet: config_json_1.default.TESTNET_CONFIG,
};
class NodeList {
    constructor(network) {
        this.nodes = [];
        this.indexes = [];
        if (network in ChainConfig) {
            this.network = network;
            this.contract = getNodeContract(this.network);
        }
        else {
            const validNetworks = Object.keys(ChainConfig);
            throw new Error(`Invalid networks. Use ${validNetworks}`);
        }
    }
    getNodes() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.nodes.length) {
                return { nodes: this.nodes, indexes: this.indexes };
            }
            else {
                const { nodes, indexes } = yield this.fetchNodes();
                this.nodes = nodes;
                this.indexes = indexes;
                return { nodes, indexes };
            }
        });
    }
    fetchNodes() {
        return __awaiter(this, void 0, void 0, function* () {
            const nodes = [];
            const indexes = [];
            const promises = [];
            const epochInfo = yield this.contract.functions.getEpochInfo(1);
            epochInfo.nodeList.forEach((node) => {
                promises.push(this.contract.functions.getNodeDetails(node));
            });
            const result = yield Promise.all(promises);
            for (let i = 0; i < result.length; i++) {
                nodes.push(`https://${result[i].declaredIp}/rpc`);
                indexes.push(result[i].position.toNumber());
            }
            return { nodes, indexes };
        });
    }
}
const getNodeContract = (network) => {
    const { providerUrl, contractAddress } = ChainConfig[network];
    const abi = [
        'function getEpochInfo(uint256 epoch) external view returns ( uint256 id, uint256 n, uint256 k, uint256 t, address[] memory nodeList, uint256 prevEpoch, uint256 nextEpoch)',
        'function getNodeDetails(address nodeAddress) external view returns ( string memory declaredIp, uint256 position, string memory tmP2PListenAddress, string memory p2pListenAddress)',
    ];
    const provider = new ethers_1.ethers.providers.JsonRpcProvider(providerUrl);
    const contract = new ethers_1.ethers.Contract(contractAddress, abi, provider);
    return contract;
};
exports.default = NodeList;
